import { render, staticRenderFns } from "./AiBookChannelConfig.vue?vue&type=template&id=f0860534&scoped=true"
import script from "./AiBookChannelConfig.vue?vue&type=script&lang=js"
export * from "./AiBookChannelConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0860534",
  null
  
)

export default component.exports